import { render, staticRenderFns } from "./IndustrySelector.vue?vue&type=template&id=485c7c28&scoped=true&lang=pug"
import script from "./IndustrySelector.vue?vue&type=script&lang=js"
export * from "./IndustrySelector.vue?vue&type=script&lang=js"
import style0 from "./IndustrySelector.vue?vue&type=style&index=0&id=485c7c28&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485c7c28",
  null
  
)

export default component.exports